<div class="flex items-center justify-center dialog-header ">
    Add New Meeting Details

    <div class="absolute right-2">
        <button
            (click)="handleClosDialog()"
            class="outline-none p-5"
        >
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>
<div class="dialog-content">
    <div>
        <div class="mb-2 font-medium">
            Title of Meeting
        </div>
        <input class="w-full" style="box-shadow: none !important;" type="text" pInputText [(ngModel)]="mettingTitle" />
    </div>
    <div  
    class="grid md:grid-cols-3 grid-cols-1 gap-4 mt-5">
        <div class="w-full">
            <div class="mb-2 font-medium">
                Meeting Date
            </div>
            <p-datepicker class=" w-full"
            [style]="{'width':'100%'}"
            appendTo="body"
            [iconDisplay]="'input'" [showIcon]="true"
            [showWeek]="true"
            [minDate]="today"
            [(ngModel)]="mettngDate" [showWeek]="true" />
        </div>
        <div class="w-full">
            <div class="mb-2 font-medium">
                Meeting Duration
            </div>
            <p-select [options]="timeDurations"
            [disabled]="!mettngDate"
            optionLabel="label" optionValue="value"
                (onChange)="handleDurationChange($event)"
            [(ngModel)]="selectedDuration" class="w-full" />
        </div>
        <div class="w-full" >
            <div class="mb-2 font-medium">
                Meeting Time
            </div>
            <p-select 
            [disabled]="!selectedDuration || !mettngDate || loading"
            [loading]="loading"
            [emptyMessage]="'No Time Slots Available'"
            [options]="timeSlots" [(ngModel)]="selectedTimeSlots"  class="w-full" />
        </div>
    </div>
    <div class="mt-5">
        <div class="mb-2 font-medium">
            Meeting Description
        </div>
        <textarea rows="5" cols="30"
        class="w-full "
        pTextarea [(ngModel)]="mettingDescription"></textarea>
    </div>
    <div class="flex justify-end  mt-4">
        <p-button
            label="Add Meeting"
            icon="pi pi-save"
            class="flex justify-end"
            [disabled]="isAdding"
            [loading]="isAdding"
            (click)="handleSaveTask()"
        ></p-button>
    </div>
</div>